import { MapUtils } from '../../utility/map-utils.js';
import { CalendarEntry } from '../../models/calendar-entry.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { Component } from '../core/component.js';
import { ICopyWithBusinessRef } from '../../contracts/copy-with-business-ref.js';
import { BusinessModuleRef } from '../../models/serializable/business-module-ref.js';

export class CalendarEntryComponent extends Component implements ICopyWithBusinessRef {
  static readonly TYPE_ID: string = 'b782326375794de3bb24f585daa836ce';

  constructor(
        public readonly calendarEntry: CalendarEntry,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return CalendarEntryComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CalendarEntryComponent {
    return new CalendarEntryComponent(
        context.fromData<CalendarEntry>(MapUtils.get<SerializedData>(map, 'calendarEntry')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'calendarEntry': context.toData(this.calendarEntry),
    };
  }

  clone(): this {
    return new CalendarEntryComponent(
        this.calendarEntry.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.calendarEntry, this.calendarEntry);
  }

  copyWithBusinessRef(businessRef: BusinessModuleRef): this {
    return new CalendarEntryComponent(
        this.calendarEntry.copyWithBusinessRef(businessRef),
    ) as this;
  }
}

export class CalendarEntryComponentBuilder extends DataModelBuilder<CalendarEntryComponent> {
  build(context: SerializationContext, map: SerializedData): CalendarEntryComponent {
    return CalendarEntryComponent.fromMap(context, map);
  }
}
